/* External Deps */
import { FC, ReactElement } from "react";
import { Outlet } from "react-router-dom";

const Creation: FC = (): ReactElement => {
  return <Outlet />;
};

export default Creation;